import { lazy } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const editByCountryAndType = {
  'energy-fr': lazy(() => import('./Energy/FR/Edit')),
  'energy-be': lazy(() => import('./Energy/BE/Edit')),
  'energy-de': lazy(() => import('./Energy/DE/Edit')),
  'energy-at': lazy(() => import('./Energy/AT/Edit')),
  'energy-it': lazy(() => import('./Energy/IT/Edit')),
  'energy-nl': lazy(() => import('./Energy/NL/Edit')),
  'telecom-fr': lazy(() => import('./Telecom/FR/Edit')),
  'telecom-it': lazy(() => import('./Telecom/IT/Edit')),
  'telecom-be': lazy(() => import('./Telecom/BE/Edit')),
  'insurance-fr': lazy(() => import('./Insurance/FR/Edit')),
  'insurance-be': lazy(() => import('./Insurance/BE/Edit')),
}

const useOrganizationEditForm = () => {
  const { t } = useTranslation()
  const { getApplicationTypeFolder } = useBusinessType({
    loaderRoutesEnergy: {},
    loaderRoutes: {},
    loaderRoutesInsurance: {},
  })
  const { country } = useSelector(selectAuthData)
  const moduleKey = `${getApplicationTypeFolder().toLowerCase()}-${country?.toLowerCase()}`
  const LocalizedModule = editByCountryAndType[moduleKey] ?? null

  return { t, LocalizedModule }
}

export default useOrganizationEditForm
